import React, { useState, useEffect } from 'react';
import '../../Styles/Styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../Styles/CheckboxList.css';
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import BackModal from '../../Components/BasicElements/BackModal';
import ConfirmModal from '../../Components/BasicElements/ConfirmModal';
import http from "../../Common/http-common";
import * as common from "../../Common/common";
import * as Comp from "../../Common/CommonComponents";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPaperPlane, faXmark } from "@fortawesome/free-solid-svg-icons";

const HolidayNotify = (props) => {
	const [cookies] = useCookies([]);
	const [userId] = useState(cookies.USER_ID);
	const [loading, setLoading] = useState(false);
	const [loadingText, setLoadingText] = useState("Loading....");
	const [notifyBy, setNotifyBy] = useState([]);
	const [yearList, setYearList] = useState([]);
	const [year, setYear] = useState([null, null]);
	const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
	const [emailList, setEmailList] = useState([]);
	const [showBackModal, setShowBackModal] = useState(false); // State for back confirmation modal
	const [hasChanges, setHasChanges] = useState(false);
	const [inputError, setInputError] = useState([]);
	const [showConfirmModal, setShowConfirmModal] = useState(false); // State for confirmation modal
	const [emailListToBeSelect, setEmailListToBeSelect] = useState([]);
	
	//#region get year list
	useEffect(() => {
		let functionName = "";
		try {
			functionName = "use Effect Get Year List";
			setLoading(true);
			setLoadingText("Getting Year List, Please wait....");
		
			http
				.get("api/holiday/GetYearList?_sysUser=" + userId, { timeout: 10000})
				.then((response) => {
					const listItems = [];
					for (var i = 0; i < response.data.length; i++) {
						listItems.push({
							key: response.data[i].HOLIDAY_YEAR,
							value: response.data[i].HOLIDAY_YEAR,
							label: response.data[i].HOLIDAY_YEAR,
						});
					}
					setYearList(listItems);
				})
				.catch((err) => {
					toast.error("Error on getting year list. PLease try again. (Send)");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading....");
				});
		} catch (err) {
			toast.error("Error on getting year list. Please try again. (Received)");
			common.c_LogWebError(props.page, functionName, err);
		}
	}, [userId]);
	//#endregion

	//region Email List
	useEffect(() => {
		let functionName = "";
			
		try {
			functionName = "Get Email";
			http
				.get(
					"api/holiday/GetEmailList?_sysUser=" + userId
				)
				.then((response) => {
					const emailList = [];
					for (var i = 0; i < response.data.length; i++) {
						emailList.push({
							key: response.data[i].USER_ID,
							value: response.data[i].EMAIL,
							label: response.data[i].EMAIL,
						});
					}
					setEmailListToBeSelect(emailList);
				})
				.catch((err) => {
					common.c_LogWebError(props.page, functionName, err);
				});
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	}, [userId]);
	//endregion

	function NotifyHoliday() {
		let functionName = "";
		try {
			functionName = props.page + NotifyHoliday.name;
			setLoading(true);
			setLoadingText("Notifying Holiday, PLease wait....")

			const selectedEmailTO = emailList.map((r) => r.value).join(',');
			const data = {
				NOTIFY_BY: notifyBy.value,
				EMAIL_TO: selectedEmailTO,
				HOLIDAY_YEAR: year.value,
				START_DATE: common.c_Dis_DateTime(startDate).val,
				END_DATE: common.c_Dis_DateTime(endDate).val,
				UPDATE_ID: userId,
				FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },
			};

			http
				.post("api/holiday/NotifyHoliday", data, { timeout: 1000000 })
				.then((response) => {
					toast.success("Notification successfully sent.");
					hideModal();
					props.onReload();
				})
				.catch((err) => {
					toast.error("No holidays found. Please try again.");
					common.c_LogWebError(props.page, functionName, err);
				})
				.finally(() => {
					setLoading(false);
					setLoadingText("Loading...");
				});
		} catch (err) {
			setLoading(false);
      setLoadingText("Loading...");
			toast.error("Failed to notify holiday. Please try again.");
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	//#endregion

	//#region Event Handle
	const selectNotifyByHandler = (val) => {
		let functionName = "";
			
		try {
			functionName = selectNotifyByHandler.name;
			if (Object.keys(val).length > 0) {
				setInputError((prevState) => ({
					...prevState,
					NOTIFY_BY: (""),
					YEAR: (""),
					DATE_RANGE: (""),
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					NOTIFY_BY: "Notify By could not be empty.",
				}));
			}
			setNotifyBy(val);
			setHasChanges(true);
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	};

	const selectEmailHandler = (val) => {
		let functionName = "";
			
		try {
			functionName = selectEmailHandler.name;
			if (Object.keys(val).length > 0) {
				setInputError((prevState) => ({
					...prevState,
					USERNAME: (""),
				}));
			}
			setEmailList([...val]);
			setHasChanges(true);
		} catch (err) {
			common.c_LogWebError(props.page, functionName, err);
		}
	};
	
	const handleYearChange = (val) => {
		setInputError((prevState) => ({
			...prevState,
			YEAR: (""),
		}));
		setYear(val);
		setHasChanges(true);
	};
	
	const handleDateChange = dates => {
		setInputError((prevState) => ({
			...prevState,
			DATE_RANGE: (""),
		}));
		setDateRange(dates);
		setHasChanges(true);
	};

	const hideModal = () => {
		setNotifyBy([]);
		setYear([]);
		setDateRange([]);
		setEmailList([]);
		setInputError([]);
		props.onHide();
	};

	const handleBack = () => {
		if (hasChanges) {
			setShowBackModal(true);
		} else {
			hideModal();
		}
	};

	const handleConfirmBack = () => {
		setShowBackModal(false); // Hide back modal
		hideModal();
		setHasChanges(false);
	};

	const handleConfirmBackCancel = () => {
		setShowBackModal(false); // Hide back modal
	};

	const handleConfirm = () => {
		var flag = true;
		if (notifyBy.value === undefined) {
			flag = false;
			setInputError((prevState) => ({
				...prevState,
				NOTIFY_BY: ("Notify By could not be empty."),
			}));
		}

		if (notifyBy.value === 'Year') {
			if (year.value === undefined) {
				flag = false;
				setInputError((prevState) => ({
					...prevState,
					YEAR: "Year cannot be empty.",
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					YEAR: "",
				}));
			}
		} else {
			if (!startDate || !endDate) {
				flag = false;
				setInputError((prevState) => ({
					...prevState,
					DATE_RANGE: "Date Range cannot be empty.",
				}));
			} else {
				setInputError((prevState) => ({
					...prevState,
					DATE_RANGE: "",
				}));
			}
		}
		if (Object.values(inputError).filter(v => v !== "").length === 0 && flag) {
			setShowConfirmModal(true);
		}
	};

	const handleConfirmModal = () => {
		NotifyHoliday();
		setShowConfirmModal(false); // Hide confirm modal
	};

	const handleConfirmModalClose = () => {
		setShowConfirmModal(false); // Hide confirm modal
	};

	return (
		<>
		<Modal show={props.showHide} onHide={hideModal} centered size="mg">
			<Modal.Header>
				<div style={{ backgroundColor: "#FF8C00", width: "100%" }}>
					<Modal.Title style={{ textAlign: "left", marginLeft: "5px" }}>Notify</Modal.Title>
				</div>
			</Modal.Header>

			<Modal.Body>
				<Comp.Select
					id="NOTIFY_BY"
					label="Notify By*"
					name="Notify By"
					options={[
						{ label: "Year", value: "Year" },
						{ label: "Date", value: "Date" }
					]}
					errorMessage={inputError.NOTIFY_BY}
					onChange={selectNotifyByHandler}
				/>

				{notifyBy.value === 'Year' ? (
					<Comp.Select
						id="YEAR"
						label="Year*"
						name="Year"
						options={yearList}
						value={year}
						errorMessage={inputError.YEAR}
						onChange={handleYearChange}
					/>
				) : notifyBy.value === 'Date' ? (
					<Comp.DateTimePicker
						id="DATE_RANGE"
						label="Date*"
						name="Date"
						errorMessage={inputError.DATE_RANGE}
						onChange={handleDateChange}
						startDate={startDate}
						endDate={endDate}
						selectsRange
						autoComplete="off"
					/>
				) : (
					<div></div>
				)}

				<Comp.Select
					id="EMAIL"
					label={
						<div>
							Recipients
							<div style={{ color: "#6c757d", fontSize: "0.75rem" }}>
								*Notify everyone if the input is blank.*
							</div>
						</div>
					}
          name="EMAIL"
          type="text"
          menuPlacement="top"
          options={emailListToBeSelect}
					closeMenuOnSelect={true}
          hideSelectedOptions={false}
          errorMessage={inputError.EMAIL}
          value={emailList}
          onChange={selectEmailHandler}
          isMulti    
				/>
			</Modal.Body>

			<Modal.Footer>
				<div className="onright-container">
					<Comp.Button
						id="btnCancel"
						type="cancel"
						onClick={handleBack}
					>
						<FontAwesomeIcon icon={faXmark} />&nbsp; Cancel
					</Comp.Button>
						
					<Comp.Button id="btnSend" onClick={handleConfirm}>
						<FontAwesomeIcon icon={faPaperPlane} />&nbsp; Send
					</Comp.Button>
				</div>
			</Modal.Footer>
		</Modal>

		{/* Success Message Modal */}
		<BackModal
			show={showBackModal}
			onHide={handleConfirmBackCancel}
			onConfirm={handleConfirmBack}
			prop="Confirm Navigation"
		>
			Are you sure you want to go back? Your changes may be lost.
		</BackModal>
		
		<ConfirmModal
			show={showConfirmModal}
			onHide={handleConfirmModalClose}
			onConfirm={handleConfirmModal}
			prop="Confirm to save"
		>
			Are you sure you want to send holiday notification?
		</ConfirmModal>

		{loading && <Comp.Loading>{loadingText}</Comp.Loading>}
		<Comp.AlertPopup />
		</>
	);
};

export default HolidayNotify;